// --------------------------------------------------------
// CANCEL MODAL - CancelModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import { GenericSolidButton, RedCancelButton } from '../UI/buttons/Button.styled'
import { H1, H2, H3, Text } from '../UI/generalLayout/Layout.styled'
import { ReactComponent as Exclamation } from '../../assets/imgs/exclamation.svg'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { ButtonAreaContainer, ModalContainer, ModalContentContainer } from './GenericModal.styled'
import Colors from '../../constants/Colors'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

import { Spacer } from '../UI/spacer/spacer'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CANCEL MODAL INTERFACE
// --------------------------------------------------------

interface ICancelModal {
    Icon?: any;
    visible: boolean;
    onCancel: any;
    onConfirm: any;
    modalTitle: string;
    modalSubtitle: string;
    cancelButtonMsg: string;
    colorButtonCancel?: string;
    colorButtonConfirm?: string;
    confirmButtonMsg: string;
    isLoading?: boolean;
}
/**
/**
 * A component that renders a Cancel modal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const GenericModal = ({ visible, onCancel, onConfirm, modalTitle, modalSubtitle, cancelButtonMsg, confirmButtonMsg, Icon = undefined, colorButtonCancel, colorButtonConfirm, isLoading = false }: ICancelModal) => {
    // --------------------------------------------------------
    // CANCEL MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Modal
                open={visible}
            >
                <ModalContainer isMobile={isMobile}>
                    <ModalContentContainer isMobile={isMobile}>
                        {Icon === undefined ? <Exclamation /> : <Icon />}
                        
                        <Spacer top={20} />
                        
                        {isMobile ? 
                            <H2 style={{ textAlign: 'center' }}>{modalTitle}</H2> : 
                            <H1 style={{ textAlign: 'center' }}>{modalTitle}</H1>
                        }
                        
                        <Spacer top={12} />
                        
                        {isMobile ? 
                            <Text style={{ fontSize: 15, textAlign: 'center' }}>{modalSubtitle}</Text> : 
                            <H3 style={{ textAlign: 'center' }}>{modalSubtitle}</H3>
                        }
                        
                        <ButtonAreaContainer>
                            {
                                cancelButtonMsg !== '' &&
                                <RedCancelButton
                                    style={{ margin: 0, width: isMobile ? '100%' : 'auto' }}
                                    color={colorButtonCancel ? colorButtonCancel : ""}
                                    onClick={onConfirm}
                                    disabled={isLoading}
                                >
                                    {cancelButtonMsg}
                                </RedCancelButton>
                            }

                            <GenericSolidButton
                                style={{ margin: 0, width: isMobile ? '100%' : 'auto' }}
                                color={colorButtonConfirm ? colorButtonConfirm : Colors.SPM600}
                                onClick={onCancel}
                                disabled={isLoading}
                            >
                                {isLoading ? <CircularProgress size={20} color="inherit" /> : confirmButtonMsg}
                            </GenericSolidButton>
                        </ButtonAreaContainer>
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>
        </>
    )
    // --------------------------------------------------------
}

export default GenericModal